var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6101_86487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7891 32.5449C20.4783 32.5449 20.1802 32.4215 19.9604 32.2017C19.7407 31.9819 19.6172 31.6838 19.6172 31.373V9.7168C19.6172 9.406 19.7407 9.10793 19.9604 8.88816C20.1802 8.66839 20.4783 8.54492 20.7891 8.54492C21.0999 8.54492 21.3979 8.66839 21.6177 8.88816C21.8375 9.10793 21.9609 9.406 21.9609 9.7168V31.373C21.9609 31.6838 21.8375 31.9819 21.6177 32.2017C21.3979 32.4215 21.0999 32.5449 20.7891 32.5449Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6172 21.7168H9.96094C9.65014 21.7168 9.35207 21.5933 9.1323 21.3736C8.91253 21.1538 8.78906 20.8557 8.78906 20.5449C8.78906 20.2341 8.91253 19.9361 9.1323 19.7163C9.35207 19.4965 9.65014 19.373 9.96094 19.373H31.6172C31.928 19.373 32.2261 19.4965 32.4458 19.7163C32.6656 19.9361 32.7891 20.2341 32.7891 20.5449C32.7891 20.8557 32.6656 21.1538 32.4458 21.3736C32.2261 21.5933 31.928 21.7168 31.6172 21.7168Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6101_86487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.78906 8.54492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.a2844f17a58143453449fa030fc4982b.svg";
export { ForwardRef as ReactComponent };